import { memo } from 'react'
import { Link } from 'react-router-dom'

import { ListItemIcon, Menu, MenuItem } from '@mui/material'
import { AddOutlined, KeyboardArrowDownOutlined, PictureAsPdfOutlined, TextFieldsOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { Button, usePopoverState } from '@collaborate-health/uikit'

import { ArticleContentType } from '../../enums'

const TrainingMaterialCreateButton: React.FC = () => {
  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  const options = [
    {
      id: ArticleContentType.Html,
      title: 'From text',
      icon: <TextFieldsOutlined />,
      href: `${Routes.trainingMaterialCreate}?type=${ArticleContentType.Html}`,
    },
    {
      id: ArticleContentType.Pdf,
      title: 'From PDF file',
      icon: <PictureAsPdfOutlined />,
      href: `${Routes.trainingMaterialCreate}?type=${ArticleContentType.Pdf}`,
    },
  ]

  return (
    <>
      <Button
        ref={anchorRef}
        startIcon={<AddOutlined />}
        endIcon={<KeyboardArrowDownOutlined />}
        color='primary'
        size='small'
        variant='contained'
        onClick={onOpen}
      >
        Create new
      </Button>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options.map(({ id, href, icon, title }) => (
          <Link key={id} to={href}>
            <MenuItem>
              <ListItemIcon>{icon}</ListItemIcon>
              {title}
            </MenuItem>
          </Link>
        ))}
      </Menu>
    </>
  )
}

export default memo(TrainingMaterialCreateButton)

